
import Vue from 'vue'
import RIcon from '@/components/icons/index.vue'

export default Vue.extend({
  name: 'RInput',
  components: {
    RIcon,
  },
  data() {
    return {
      visible: false,
    }
  },
  props: {
    legend: {
      type: String,
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    email: {
      type: Boolean,
    },
    password: {
      type: Boolean,
    },
    value: {
      type: String,
    },
    id: {
      type: String,
    },
    fullWidth: {
      type: Boolean,
    },
    forgetful: {
      type: Boolean,
    },
    required: {
      type: Boolean,
      default: false,
    },
    labelBackground: {
      type: String,
      default: 'var(--bgPrimary)',
    },
    labelStyle: {
      type: String,
    },
    autofocus: {
      type: Boolean,
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [Number, String],
    },
    showCharCount: {
      type: Boolean,
      default: false,
    },
    selectedTextToDot: {
      type: Boolean,
      default: false,
    },
    inputHeight: {
      type: String,
      default: '44',
    },
    bgColor: {
      type: String,
      default: 'var(--bgSecondary)',
    },
    inputBorder: {
      type: String,
      default: 'var(--rinputBorder)',
    },
    inputNotFocusedColor: {
      type: String,
      default: 'var(--textSecondary)',
    },
    inputFocusTop: {
      type: String,
      default: '-8px',
    },
    inputFocusColor: {
      type: String,
      default: 'var(--cta)',
    },
    rows: {
      type: Number,
      default: 2,
    },
  },
  mounted() {
    if (!this.disabled) {
      this.autofocus && this.focus()
      this.selectedTextToDot && this.selectTextToDot()
    }
  },
  methods: {
    focus(): void {
      ;(this.$refs.input as HTMLInputElement).focus()
    },
    selectTextToDot(): void {
      const dotPos = this.value.indexOf('.')
      ;(this.$refs.input as HTMLInputElement).setSelectionRange(0, dotPos)
    },
  },
  computed: {
    identifier(): string {
      return `${(this.label || this.type || '').replace(/ /gi, '-').toLowerCase()}-input`
    },
    passwordVisiblityId(): string {
      return `${this.identifier}-password-visiblity`
    },
    type(): string {
      return this.password && !this.visible ? 'password' : this.email ? 'email' : 'text'
    },
    extraLabelStyle(): string {
      if (this.labelBackground) {
        return `
        background: ${this.labelBackground}`
      }
      return ''
    },
    cssVars(): { [key: string]: string } {
      return {
        '--bg-color': this.bgColor,
        '--inputHeight': this.inputHeight + 'px',
        '--inputBorder': this.inputBorder,
        '--inputFocusTop': this.inputFocusTop,
        '--inputFocusColor': this.inputFocusColor,
        '--labelBackground': this.labelBackground,
      }
    },
    component(): string {
      return this.textarea ? 'textarea' : 'input'
    },
    charCount(): string {
      return `${this.value.length}${this.maxlength ? ' / ' + this.maxlength : ''}`
    },
  },
  watch: {
    disabled(val) {
      if (!val && this.autofocus) {
        // nextTick is needed here, because we cannot focus on
        // a disabled element - HTML must rerender first.
        this.$nextTick(() => {
          this.focus()
        })
      }
    },
  },
})
